// "You" è derivato a runtime dalla sessione: il member il cui userId coincide
// con l'utente loggato. Il flag isYou stored è legacy (dati pre shared-groups
// rimasti solo nel mirror localStorage) e vale solo come fallback.
export function youOf(group, sessionUserId) {
  const members = group?.members ?? []
  return (
    (sessionUserId && members.find(m => m.userId === sessionUserId)) ||
    members.find(m => m.isYou) ||
    null
  )
}

// Nome proprio + iniziale del cognome: "Alberto Marson" → "Alberto M."
// (nome singolo → invariato: "Hyur" → "Hyur")
export function shortName(name) {
  const parts = String(name ?? '').trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0]
  return `${parts[0]} ${parts[1][0].toUpperCase()}.`
}

// Factory di label: memberLabel(memberId) → nome PROPRIO del member. Anche
// l'utente della sessione è mostrato col suo nome reale (scelta 2026-07-21:
// niente "tu"/"you" nelle liste — youOf resta solo per logica e default).
// Se due membri hanno lo stesso nome proprio si aggiunge l'iniziale del
// secondo token ("Alberto M." / "Alberto R.") per non confonderli.
export function makeMemberLabel(group) {
  const members = group?.members ?? []
  const short = {}
  const count = {}
  for (const m of members) {
    const s = shortName(m.name)
    short[m.id] = s
    const k = s.toLowerCase()
    count[k] = (count[k] ?? 0) + 1
  }
  const byId = {}
  for (const m of members) {
    // Omonimi anche dopo l'iniziale ("Alberto M." x2) → nome completo
    const dup = count[short[m.id].toLowerCase()] > 1
    byId[m.id] = (dup ? m.name : short[m.id]) || m.name || '?'
  }
  return (mid) => byId[mid] || '?'
}
